import React from "react";

export default function OneCardMeter({ data }) {
  const resultDTO = data?.casinoIndividualResultDTO || {};
  const casinoCardResultMaps = resultDTO?.casinoCardResultMaps || [];
  const casinoIndividualResultMaps = resultDTO?.casinoIndividualResultMaps || [];

  const getResultByType = (resultFor) => {
    const item = casinoIndividualResultMaps.find(
      (el) => el.resultFor === resultFor
    );
    if (!item) return "";
    return Array.isArray(item.result) ? item.result[0] : item.result;
  };

  const fighterACards =
    casinoCardResultMaps.find((el) => el.resultFor === "Fighter A")?.result || [];
  const fighterBCards =
    casinoCardResultMaps.find((el) => el.resultFor === "Fighter B")?.result || [];

  const winner = getResultByType("Winner");
  const points = getResultByType("Points");

  const matchTime = resultDTO.createdAt
    ? new Date(resultDTO.createdAt + "Z").toLocaleString()
    : "";

  return (
    <div className="modal-dialog modal-xl">
      <div className="modal-content">
        <div className="modal-body">
          <div className="casino-result-modal">
            <div className="casino-result-round-id">
              <span>
                <b>Round Id: </b> {resultDTO.marketId || ""}
              </span>
              <span>
                <b>Match Time: </b> {matchTime}
              </span>
            </div>
            <div className="row mt-2">
              <div className="col-md-6 text-center">
                <h4 className="result-title">Fighter A</h4>
                <div className="casino-result-cards">
                  {fighterACards.map((card, idx) => (
                    <img
                      key={idx}
                      src={`https://g1ver.sprintstaticdata.com/v53/static/front/img/cards/${card}.jpg`}
                      alt={`Fighter A Card ${idx + 1}`}
                    />
                  ))}
                  {winner === "Fighter A" && (
                    <div className="casino-winner-icon">
                      <i className="fas fa-trophy" />
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-6 text-center">
                <h4 className="result-title">Fighter B</h4>
                <div className="casino-result-cards">
                  {fighterBCards.map((card, idx) => (
                    <img
                      key={idx}
                      src={`https://g1ver.sprintstaticdata.com/v53/static/front/img/cards/${card}.jpg`}
                      alt={`Fighter B Card ${idx + 1}`}
                    />
                  ))}
                  {winner === "Fighter B" && (
                    <div className="casino-winner-icon">
                      <i className="fas fa-trophy" />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row mt-2 justify-content-center">
              <div className="col-md-6">
                <div className="casino-result-desc">
                  <div className="casino-result-desc-item">
                    <div>Winner</div>
                    <div>{winner}</div>
                  </div>
                  <div className="casino-result-desc-item">
                    <div>Points</div>
                    <div>{points}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
